const TourUtils = {
    ACTIONS: {
        NEXT: 'next',
        CLOSE: 'close',
        RESET: 'reset',
    },
};

export default TourUtils;
